import { THEME_MODES } from "../constants.js";
import { isNonNullish } from "remeda";
//#region src/utils/theme.ts
const isThemeMode = (value) => isNonNullish(value) && THEME_MODES.includes(value);
//#endregion
export { isThemeMode };

//# sourceMappingURL=theme.js.map